import React from 'react';

const Container = ({className, ...props}) => {
    return (
        <div className={`bg-ea_soft p-4 ${className}`} {...props}>
            {props.children}
        </div>
    );
};

export default Container;
